import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "preview", "image", "dropzone"]
  
  browse(event) {
    const dropzone = event.currentTarget
    const type = dropzone.dataset.type
    const input = this.findInputByType(type)

    if (input) {
      input.click()
    }
  }
  
  preview(event) {
    const input = event.currentTarget
    const type = input.dataset.type
    
    if (input.files && input.files[0]) {
      this.readAndPreviewFile(input.files[0], type)
    }
  }
  
  dragOver(event) {
    event.preventDefault()
    event.currentTarget.classList.remove('border-gray-300')
    event.currentTarget.classList.add('border-green-400', 'bg-green-50')
  }
  
  dragLeave(event) {
    event.preventDefault()
    event.currentTarget.classList.remove('border-green-400', 'bg-green-50')
    event.currentTarget.classList.add('border-gray-300')
  }
  
  drop(event) {
    event.preventDefault()
    const dropzone = event.currentTarget
    dropzone.classList.remove('border-green-400', 'bg-green-50')
    dropzone.classList.add('border-gray-300')
    
    const type = dropzone.dataset.type
    const input = this.findInputByType(type)
    
    if (event.dataTransfer.files.length && input) {
      input.files = event.dataTransfer.files
      this.readAndPreviewFile(event.dataTransfer.files[0], type)
    }
  }
  
  findInputByType(type) {
    return this.inputTargets.find(input => input.dataset.type === type)
  }
  
  readAndPreviewFile(file, type) {
    if (!file || !file.type.match(/^image\//)) return
    
    const reader = new FileReader()
    const previewContainer = this.findPreviewByType(type)
    
    if (!previewContainer) return
    
    const imageElement = previewContainer.querySelector('img')
    
    reader.onload = (e) => {
      imageElement.src = e.target.result
      previewContainer.classList.remove('hidden')
    }
    
    reader.readAsDataURL(file)
  }
  
  findPreviewByType(type) {
    return this.previewTargets.find(preview => preview.dataset.type === type)
  }
}